module.exports = __webpack_public_path__ + "img/sBuffK_350x350.91567766.jpg";